import React, { useRef, useState } from 'react';

import axios, { Canceler } from 'axios';
import useCancel from '../Hooks/CancelFetch';
import Backend from '../../utils/Backend';
import { validateFormRequest } from '../../helper/validators';
import { toast } from 'react-toastify';

import Loader from '../Loader';

import styles from './styles.module.scss'
import { useIsBoiWebsite } from "../Context/WebsiteType";

interface IForm {
  header: string, 
  text: string,
  form_type: string,
  submittedText: string,
  askAgain?: boolean,
  textareaPlaceholder?: string,
}

export default function Form({header, text, submittedText, form_type, askAgain, textareaPlaceholder} : IForm) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  
  const dataHolderRef = useRef<HTMLDivElement>(null);

  const submitCancelRef = useRef<Canceler>()
  const isBoiWebsite = useIsBoiWebsite();

  useCancel(submitCancelRef.current)
  const sendRequest = () => {
    if (!validateFormRequest(name, email, message, phone, toast.error)) return
    
    setLoading(true);

    const { promise, cancel } = Backend.formRequest(
      name, email, message, form_type,
      undefined, phone
    )
    
    submitCancelRef.current = cancel;

    promise.then((res) => {
      if (res.status === 201) {
        if (dataHolderRef && dataHolderRef.current) {
          dataHolderRef.current.classList.toggle(styles.disappear);
        }
        setTimeout(() => {
          setSubmitted(true);
        }, 750)
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) return;
      
      toast.error("Internal server error occured. Please, try again later.")
      setLoading(false)
    }); 
  }

  const onAskNewQuestion = () => {
    setMessage("");
    setSubmitted(false);
    setLoading(false);
  }

  return (
    <div className={styles.formHolder}>
      <h1 className={styles.header}>{ header }</h1>
      <p className={styles.subHeader}>{ submitted ? submittedText : text}</p>
      
      {
        !submitted &&
        <div className={styles.dataHolder} ref={dataHolderRef}>
          <div className={`${styles.input} transparent-input`}>
            <div>
              <input 
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Your Name *"
              />
            </div>
          </div>

          <div className={`${styles.input} transparent-input`}>
            <div>
              <input 
                type="text"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email *"
              />
            </div>
          </div>

          <div className={`${styles.input} transparent-input`}>
            <div>
              <input 
                type="text"
                value={phone}
                onChange={e => {
                  setPhone(e.target.value.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''))
                }}
                placeholder='Phone Number *'
              />
            </div>
          </div>

          <div className={`${styles.input} transparent-input`}>
            <div>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder={textareaPlaceholder || 'Request *'}
                maxLength={1024}
              />
            </div>
          </div>
          
          <div className={styles.submitHolder}>
            { loading ? 
              <Loader /> :
              <button className={`${isBoiWebsite ? 'light-blue-button-boi' : 'blue-button'}`} onClick={sendRequest}>Send</button>
            }
          </div>
        </div>  
      }

      {(submitted && askAgain) && (
        <button className={`${styles.newQuestionButton} ${isBoiWebsite ? 'dark-blue-button-boi' : 'blue-button'}`} onClick={onAskNewQuestion}>
          Ask Another Question
        </button>
      )}
    </div>
  )
};
